<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Email Queue" />
    <div class="container-fluid">
      <div class="card p-4">
        <div class="d-flex justify-content-between">
          <h3>Email Queue ({{ rows.length }})</h3>
          <div :style="{ width: queue === '' ? '12%' : 'auto' }">
            <v-select id="queue-id" placeholder="Queue" label="name" :multiple="true" v-model="queueSelected"
              :options="queueArr"></v-select>
          </div>
        </div>
        <dataTableVue ref="refDataTable" :isSearch="false" :isExport="false" :isFilter="false" :renderMode="'csr'"
          @load="refreshTable" v-bind:data="{
            columns: columns,
            rows: rows,
            rowCustom: 'rowMailQueue',
          }" @deleteRow="deleteRow" @closeRow="closeRow" @editRow="editRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'Queue',
          field: 'queue',
          hidden: false,
        },
        {
          label: 'Recieved Time',
          field: 'received_date_time',
          hidden: false,
        },
        {
          label: 'ID',
          field: 'index',
          hidden: false,
        },
        {
          label: 'From',
          field: 'from',
          hidden: false,
          // width: '10%',
        },
        {
          label: 'Subject',
          field: 'subject',
          hidden: false,
          // width: '30%',
        },
        {
          label: 'Agent',
          field: 'user_name',
          hidden: false,
          // width: '15%',
        },
        {
          label: 'Case No.',
          field: 'case_no',
          hidden: false,
          // width: '8%',
        },
        // {
        //   label: 'Action',
        //   field: 'action',
        //   hidden: false,
        //   width: '20%',
        // },
      ],
      data: null,
      exportDetail: {},
      queueArr: [],
      queueSelected: '',
      queue: '',
      isSwalProcessing: false
    };
  },
  async created() {

    await this.loadItems();
  },
  async mounted() {
    const self = this;
    this.initRoleUser();
    this.$refs.refDataTable.setLimit(100);
    this.$refs.refDataTable.setCurrentPerPage(100);
    this.$root.$on('realtimeMailQueue', (data) => {
      self.loadItems();
    });
  },
  beforeDestroy() {
    this.$root.$off('realtimeMailQueue', null);
  },
  watch: {
    queueSelected(newVal) {
      this.queue = newVal.map(item => item._id).join(',');
      this.loadItems()
    }
  },
  methods: {
    editRow(item) {
      // console.log('openModal', item);
      let url = `/api/desktop/service_now/${item[1]._id}/cat/${item[0].key}`;

      this.$swal.fire({
        html: `
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">
      Confirm<br>${item[0].text}?
    </div>
    <div>Subject: ${item[1].subject}</div>
  `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2971FF',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then((result) => {
          if (result.isConfirmed) {
            if (this.isSwalProcessing) {
              console.log('double click');
              return
            };
            this.isSwalProcessing = true;
            this.$swal.fire({
              title: 'loading...',
              allowOutsideClick: false,
              didOpen: () => {
                this.$swal.showLoading();
              },
            });
            requestService
              .PostFetch('ccp', url)
              .then(() => {
                this.$swal.close();
                this.$swal.fire({
                  icon: 'success',
                  title: 'Create Success',
                  showConfirmButton: false,
                  timer: 3000,
                });
                this.isSwalProcessing = false;
                this.loadItems();
              })
              .catch((err) => {
                this.isSwalProcessing = false;
                this.$swal.close();
                let errorMessage = 'Something went wrong. Please try again.';
                try {
                  const error = JSON.parse(err);
                  errorMessage = error?.error?.message || JSON.stringify(error);
                } catch (e) {
                  errorMessage = typeof err === 'string' ? err : String(err);
                }

                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: errorMessage,
                });

                if (errorMessage == "job id is already assigned or processing" || errorMessage == "job was assigned") {
                  this.loadItems()
                }
              });
          }
        });
    },
    getAllQueue() {
      let url = `/api/mail/queue_management`
      requestService.GetFetch('ccp', url).then((res) => {
        if (res.status == 200) {
          res.text().then(async (text) => {
            const data = text && JSON.parse(text);
            // console.log('data: ', data.data, data.data.length)
            this.queueArr = data.data.filter((e) => e.status === true);
          });
        }
      })
    },
    refreshTable(obj) {
      this.$refs.refDataTable.setCurrentPerPage(obj.params.limit);
    },
    initRoleUser() {
      let userinfo = localStorage.getItem('userinfo');
      userinfo = JSON.parse(userinfo);
      if (
        userinfo.role_ccp != undefined &&
        (userinfo.role_ccp == 'admin' || userinfo.role_ccp == 'Admin')
      ) {
        this.columns.push({
          label: 'Action',
          field: 'action',
          hidden: false,
          width: '10%',
        });
      }
    },
    closeRow(value) {
      const url = `/api/desktop/close/${value.row._id}/job`;
      this.$swal
        .fire({
          title: 'Confirm to close job ?',
          // text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, close it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            const object = {};
            requestService
              .PostFetch('ccp', url, object)
              .then(() => {
                this.$swal.fire(
                  'Close !',
                  'Your mail has been close.',
                  'success'
                );

                this.$root.$data.WorkerIO.port.postMessage([
                  'closeJob',
                  value.row.user_id,
                  value.row._id,
                ]);
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    deleteRow(value) {
      const url = `/api/desktop/delete/${value._id}/job`;

      this.$swal
        .fire({
          title: `Confirm to delete ${value.subject} ?`,
          // text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('ccp', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your mail has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    async loadItems() {
      let userinfo = localStorage.getItem("userinfo")
      userinfo = JSON.parse(userinfo)
      // user_id
      await this.getAllQueue()
      var url = `/api/desktop/waiting/queue?queue=${this.queue}`;
      return requestService
        .GetFetch('ccp', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data != null) {
                // console.log('data', data.data);

                let myQueues = this.queueArr.filter((obj) => {
                  return (
                    obj.member.some((memberId) => memberId == userinfo.user_id) &&
                    obj.status
                  );
                });
                this.queueArr = myQueues
                // console.log('myQueues: ', myQueues)

                const mappedData2 = data.data.map(item => {
                  const matchQueue2 = myQueues.find(obj => obj._id === item.queue);
                  if (matchQueue2) {
                    let queueName2 = matchQueue2 ? matchQueue2.name : null;
                    return {
                      ...item,
                      case_no: item.case_no ?? '',
                      queue: queueName2
                    };
                  }
                }).filter(Boolean);
                self.rows = data.data
                // console.log('rows', this.rows);

                self.rows = mappedData2

                // const mappedData = data.data.map(item => {
                //   const matchQueue = this.queueArr.find(obj => obj._id === item.queue);
                //   let queueName = matchQueue ? matchQueue.name : null;
                //   return { ...item, queue: queueName };
                // });
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style></style>
